module.exports = __webpack_public_path__ + "static/b-uti-23e20de788e4317b2861baaca23c037e.jpg";